import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  ResponsiveContainer,
  LabelList
} from 'recharts';
import { Box, Card, CardHeader } from '@mui/material';
import * as MuiIcons from '@mui/icons-material'; // Importa todos os ícones como objeto

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#a4de6c', '#d88884'];

// 🔍 Função recursiva para extrair todos os motivos com labels e ícones
function extractReasonsFromParams(node, result = {}) {
  if (!node || !node.options) return result;

  node.options.forEach(option => {
    if (option.value?.startsWith('naoConvertido_')) {
      result[option.value] = {
        label: option.label,
        icon: option.icon
      };
    }

    if (option.options && option.options.length > 0) {
      extractReasonsFromParams(option, result);
    }
  });

  return result;
}

function extractNonConvertedData(operations, params) {
  const reasonMap = extractReasonsFromParams(params.dialogOptions.inService_available.options.find(opt => opt.value === 'naoConvertido'));

  const counts = {};
  operations.forEach(op => {
    const { finish_reason } = op;
    if (finish_reason?.startsWith('naoConvertido_')) {
      counts[finish_reason] = (counts[finish_reason] || 0) + 1;
    }
  });

  return Object.entries(counts).map(([value, count]) => {
    const reasonInfo = reasonMap[value] || { label: value, icon: 'HelpOutline' };
    return {
      value,
      label: reasonInfo.label,
      count,
      icon: reasonInfo.icon
    };
  });
}

const HorizontalBarReasons = ({ operations, params }) => {
  const data = extractNonConvertedData(operations, params);

  return (
    <Card sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <CardHeader title="Motivos de Não Conversão" />
      <Box width="100%" height={400}>
        <ResponsiveContainer>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ top: 20, right: 40, left: 60, bottom: 20 }}
          >
            <XAxis type="number" />
            <YAxis
              type="category"
              dataKey="label"
              tick={({ x, y, payload }) => {
                const { value } = payload;
                const item = data.find(d => d.label === value);
                const IconComponent = MuiIcons[item?.icon] || MuiIcons.HelpOutline;

                return (
                  <g transform={`translate(${x - 50},${y})`}>
                    <foreignObject x={-25} y={-10} width={20} height={20}>
                      {IconComponent && <IconComponent fontSize="small" />}
                    </foreignObject>
                    <text x={0} y={0} dy={5} fill="#333" fontSize={10}>
                      {value}
                    </text>
                  </g>
                );
              }}
            />
            <Tooltip formatter={(value, name, props) => [`${value}`, 'Qtd.']} />
            <Bar dataKey="count" fill="#8884d8">
              <LabelList dataKey="count" position="right" />
              {data.map((_, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default HorizontalBarReasons;
